import React, { useState } from 'react'
import Award1 from '../../Images/Awards/JillaSahakari.jpg'
import Award2 from '../../Images/Awards/JillaSaving.jpg'
import Award3 from '../../Images/Awards/NEFSCUN.jpg'
import Award4 from '../../Images/Awards/NEFSCUNGopal.jpg'

const CooperativeAwards = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState('');

    const awardList = [
        {
            id: '1',
            awardName: 'प्रशंसा पत्र',
            awardImg: Award1,
            path: '/award1'
        },
        {
            id: '2',
            awardName: 'प्रशंसा पत्र',
            awardImg: Award2,
            path: '/award2'
        },
        {
            id: '3',
            awardName: 'प्रशंसा पत्र',
            awardImg: Award3,
            path: '/award3'
        },
        {
            id: '4',
            awardName: 'सम्मान पत्र',
            awardImg: Award4,
            path: '/award4'
        },
    ]

    const handleImageClick = (image) => {
        setCurrentImage(image);
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentImage('');
    }

    return (
        <>
            <div className='branches-div'>
                <div className='branches-body'>
                    <div className='card-container'>
                        {awardList.map((item, id) => {
                            return (
                                <div className='card' key={id}>
                                    <div className='inner'>
                                        <div className='img-holder' onClick={() => handleImageClick(item.awardImg)}>
                                            <img src={item.awardImg} alt='award-Image' />
                                        </div>
                                        <div className='detail'>
                                            <h3>{item.awardName}</h3>
                                            {/* <button onClick={() => handleViewClick(item.awardImg)}>View</button> */}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className='modal'>
                    <span className='close' onClick={closeModal}>&times;</span>
                    <img className='modal-content' src={currentImage} alt='fullscreen' />
                </div>
            )}
        </>
    )
}

export default CooperativeAwards